







































import axios from 'axios';
import { User } from '@/types/GlobalTypes';
import { get } from 'lodash';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';

export default {
    name: 'CoAddMemberDialogue',
    components: {
        CoConfirmation,
        CoUser,
        CoInput,
        CoButton,
    },
    props: {
        members: {
            type: Array,
            required: false,
            default: () => [] as User[],
        },
        excludedMembers: {
            type: Array,
            required: false,
            default: () => [] as User[],
        },
    },
    data() {
        return {
            membersCandidates: [] as User[],
        };
    },
    methods: {
        searchUsers(query, source) {
            // search for users
            return new Promise((resolve, reject) => {
                // exit if query is less than 2 characters
                if (!query || query.length < 2) {
                    resolve([]);
                    return;
                }
                // fetch the search results
                axios({
                    method: 'GET',
                    url: `/search/user/${query}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    cancelToken: source ? source.token : null,
                })
                    .then((response) => {
                        const results = get(response, 'data', []);
                        // filter out users that are already in the membersCandidates list  or in the members list
                        const filtered = results.filter((el) => {
                            const found = this.membersCandidates.find((m) => m.ID === el.ID);
                            if (found) {
                                return false;
                            }
                            const found2 = this.members.find((m) => m.ID === el.ID);
                            if (found2) {
                                return false;
                            }
                            return true;
                        });

                        const mapped = filtered.map((el) => {
                            // if the user is not in the same space, show space thumbnail
                            let spaceIcon = null;
                            if (get(el, 'Space.ID', null) !== this.$store?.state?.space?.ID) {
                                spaceIcon = {
                                    imageURL: get(el, 'Space.FaviconURL', null),
                                    text: get(el, 'Space.Name', null),
                                    color: get(el, 'Space.PrimaryColor', null),
                                };
                            }
                            return {
                                thumbnailLabel: spaceIcon,
                                label: get(el, 'Profile.Name', ''),
                                thumbnail: get(el, 'Profile.ImageURL', ''),
                                // disable if the user is in the excludedMembers list
                                disabled: this.excludedMembers.some((m) => m.ID === el.ID),
                                value: el,
                            };
                        });
                        resolve(mapped);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        removeCandidate(index) {
            this.membersCandidates.splice(index, 1);
        },
        selectCandidate(user) {
            const u = get(user, 'value', null);
            if (!u) {
                return;
            }
            this.membersCandidates.push({
                ...u,
            });
        },
        addMembers() {
            this.$emit('add-members', this.membersCandidates);
            this.membersCandidates = [];
        },
    },
};
